<template>
    <div>
        <nav class="navbar fixed-top navbar-expand-lg navbar-light bg-light-tr">
            <div class="container">
                <a class="navbar-brand" href="#" @click.prevent="goHome()">
                    <img src="../../assets/PimblrLogo.png" alt="Pimblr">
                </a>

                    <ul class="navbar-nav my-2 my-lg-0">

                        <router-link v-if="!isLoggedIn" to="/login" tag="li" class="nav-item" activeClass="active"><a class="nav-link">Login</a></router-link>
                        <router-link v-if="!isLoggedIn" to="/register" tag="li" class="nav-item" activeClass="active"><a class="nav-link">Register</a></router-link>

                        <router-link
                                v-if="isLoggedIn"
                                :to="{name: 'MessageToBlog', params:{blogUrl:blog.url}}"
                                tag="li"
                                class="nav-item"
                                activeClass="active">
                            <a class="btn btn-outline-primary">Send Message</a>
                        </router-link>
                        <li>&nbsp;</li>
                        <li v-if="isLoggedIn && canGoBack" class="nav-item">
                            <a href="#" class="btn btn-outline-primary" @click.prevent="goBack()">go Back</a>
                        </li>

                    </ul>

            </div>
        </nav>
    </div>
</template>

<script>

    import SearchField from '../ui/SearchField.vue'
    import FollowButton from '../ui/buttons/FollowButton.vue';

    export default {
        name: 'BlogNavigation',
        props:['blog'],
        data(){
            return {
                navOpen: false
            }
        },
        computed: {
            isLoggedIn(){
                return this.$store.state.user.isLoggedIn;
            },
            canGoBack(){
                return history.length > 1
            }
        },
        created () {},
        methods: {
            toggleNav(){
                this.navOpen = !this.navOpen;
            },
            logout(){
                this.$store.commit('user/unsetToken');
                this.$router.push({name: 'Login'})
            },
            goHome(){
              if(this.isLoggedIn){
                this.$router.push({name:'Dashboard'})
              } else {
                this.$router.push({name:'Startpage'})
              }
            },
            goBack(){
                this.$router.go(-1);
            }
        },
        components: {
            SearchField,
            FollowButton
        }
    }
</script>

<style lang="sass" scoped>
    .bg-light-tr
        background-color: rgba(255,255,255,.9)

    .navbar-brand img
        height: 26px
</style>



// WEBPACK FOOTER //
// src/components/layout/BlogNavigation.vue